(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function renderTime(el, diff) {
    if (diff < 0) diff = 0;
    el.querySelector('[data-days]').textContent    = pad(Math.floor(diff / 86400000));
    el.querySelector('[data-hours]').textContent   = pad(Math.floor((diff % 86400000) / 3600000));
    el.querySelector('[data-minutes]').textContent = pad(Math.floor((diff % 3600000) / 60000));
    el.querySelector('[data-seconds]').textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  /* ── Evergreen: each visitor gets their own N-day timer (unchanged) ── */
  function initEvergreen(el, id, cycleDays) {
    var cycleMs = cycleDays * 24 * 60 * 60 * 1000;
    var storageKey = 'hs_cd_' + id;

    function getEndTime() {
      try {
        var stored = JSON.parse(localStorage.getItem(storageKey));
        if (stored && stored.cycleDays === cycleDays && stored.endTime > Date.now()) {
          return stored.endTime;
        }
      } catch (e) {}
      var t = Date.now() + cycleMs;
      try { localStorage.setItem(storageKey, JSON.stringify({ endTime: t, cycleDays: cycleDays })); } catch (e) {}
      return t;
    }

    var endTime = getEndTime();

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        endTime = Date.now() + cycleMs;
        try { localStorage.setItem(storageKey, JSON.stringify({ endTime: endTime, cycleDays: cycleDays })); } catch (e) {}
        diff = cycleMs;
      }
      renderTime(el, diff);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── Fixed: counts down to one date (now read in the store's time zone) ── */
  function initFixed(el) {
    var endTime = (parseInt(el.dataset.endTs, 10) || 0) * 1000;
    if (!endTime) endTime = new Date((el.dataset.endDate || '').trim()).getTime();

    if (!endTime || isNaN(endTime)) {
      renderTime(el, 0);
      return;
    }

    var timer;

    function tick() {
      var diff = endTime - Date.now();
      renderTime(el, diff);
      if (diff <= 0) clearInterval(timer);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  /* ── Scheduled: start → end, pause, reset → repeat. Same for every visitor. ──
     All scheduled widgets share one clock; the schedule itself lives in
     window.HS_OFFER (snippets/hs-offer-schedule.liquid). */
  var STATE_TEXT = {
    active: 'Live now',
    waiting: 'Not started yet',
    over: 'Campaign ended',
    invalid: 'Check the dates'
  };

  function initScheduled(widgets) {
    var offer = window.HS_OFFER;
    var notes = document.querySelectorAll('[data-hs-countdown-note-state]');

    if (!offer || typeof offer.apply !== 'function') {
      widgets.forEach(function (el) { renderTime(el, 0); });
      return;
    }

    function tick() {
      var now = Date.now();
      var state = offer.apply(now); /* also updates <html data-hs-offer-view> */
      var diff = state.target ? state.target - now : 0;

      widgets.forEach(function (el) { renderTime(el, diff); });
      notes.forEach(function (n) { n.textContent = 'now: ' + (STATE_TEXT[state.phase] || state.phase); });
    }

    tick();
    setInterval(tick, 1000);
  }

  var scheduled = [];

  document.querySelectorAll('[data-countdown-widget]').forEach(function (el) {
    var type = (el.dataset.type || 'evergreen').trim();
    var id = (el.dataset.id || 'global').trim();

    if (type === 'scheduled') {
      scheduled.push(el);
    } else if (type === 'fixed') {
      initFixed(el);
    } else {
      var cycleDays = parseInt(el.dataset.cycleDays, 10);
      if (!cycleDays || cycleDays < 1) cycleDays = 3;
      initEvergreen(el, id, cycleDays);
    }
  });

  /* Run the schedule even with no timer on the page, so the coupon code
     still hides/shows on time. */
  if (scheduled.length || window.HS_OFFER) initScheduled(scheduled);
})();
